import routes from "../../common/api-routes";
import {HttpAuthGet, HttpAuthPost, HttpAuthPut, HttpAuthPut1} from "../../../../../core/services/common/HttpRequestBuilder"


const gateFilterList = (parameters) => {

    let result = HttpAuthGet(routes.GATE_FILTER_LIST, parameters);
    return result;
}

const GateService = {
    gateFilterList
}

export default GateService
